export default [
  'BOTTireWarrantyContent',
  'BOTTireWarrantyPageBanner',
  'BOTTireWarrantyDescriptionTeaser'
]

/* Appears on /resources/voiding-your-tire-warranty */
